module.exports = __webpack_public_path__ + "static/media/avalonbh.48ead94e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/portfolios/avalonbh.png
// module id = 294
// module chunks = 0